<template>
  <div
    v-on:dragenter="prefentDefault"
    v-on:dragover="prefentDefault"
    v-on:drop="dropFile"
    class="upload-container"
  >
    <FileRow
      v-for="(file, index) in files"
      :key="`file-row-${index}`"
      :file="file"
      :removeCallback="removeCallback"
    />
    <input
      @change="addUploadImage"
      type="file"
      ref="fileInput"
      class="file-input"
    />
    <button
      @click="() => $refs.fileInput.click()"
      class="upload-button"
    >
      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" />
      </svg>
    </button>
  </div>
</template>

<script>
import FileRow from './FileRow.vue';

export default {
  props: ['value'],
  data() {
    return {
      files: this.value,
    };
  },
  components: {
    FileRow,
  },
  methods: {
    prefentDefault(evt) {
      evt.preventDefault();
    },
    dropFile(evt) {
      console.log(evt.dataTransfer.files)
      evt.dataTransfer.files.forEach((file) => {
        this.addFileToFileList(file);
      });
      evt.preventDefault();
    },
    addUploadImage(evt) {
      this.$refs.fileInput.files.forEach((file) => {
        this.addFileToFileList(file);
        this.$refs.fileInput.value = "";
      });
      // evt.preventDefault();
    },
    removeCallback(file) {
      this.files = this.files.filter((oldFile) => oldFile !== file);
      this.$emit('input', this.files);
    },
    addFileToFileList(file) {
      this.files.push(file);
      this.$emit('input', this.files);
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 1px dashed #4A5259;
}

.file-input {
  display: none;
}

.upload-button {
  margin: 10px;
  background-color: #9C0020;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: none;
}
</style>